/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { ComponentSettings } from '@bingads-webui-theme-2018/theme-fluent';

class UnStyledLearnMoreLink extends PureComponent {
  static defaultProps = {
    linkText: 'LearnMore',
    label: null,
    ariaLabel: null,
    text: '',
    href: '#!',
    linkType: 'helpPopup',
    onLinkClick: undefined,
  }

  render() {
    const {
      ariaLabel, label, text, linkText, topic, href, linkType, classes, onLinkClick,
    } = this.props;

    const helpTopic = `help:${topic}`;
    const aria = ariaLabel || `${label || text} ${linkText}`;
    const learnMoreLink = {
      helpPopup: (<a className="HelpTopic clickable" query={helpTopic} href={href} aria-label={aria} role="button">{linkText}</a>),
      fwdLink: (<a className="Fwlink clickable" href={`http://go.microsoft.com/fwlink?LinkId=${topic}`} target="_apexPlatformHelp" aria-label={aria} role="button">{linkText}</a>),
      delegate: (<a className="clickable" href={href} aria-label={aria} role="button" onClick={onLinkClick}>{linkText}</a>),
    };

    return (<span className={classes.link}>{text} {learnMoreLink[linkType]}</span>);
  }
}

UnStyledLearnMoreLink.propTypes = {
  text: PropTypes.string,
  topic: PropTypes.string.isRequired,
  linkText: PropTypes.string,
  label: PropTypes.string,
  ariaLabel: PropTypes.string,
  href: PropTypes.string,
  linkType: PropTypes.string,
  classes: PropTypes.shape({
    link: PropTypes.string.isRequired,
  }).isRequired,
  onLinkClick: PropTypes.func,
};

export const LearnMoreLink = ({
  isUnderlineLink,
  isGreyBackground,
  ...props
}) => {
  const { internalLinkStyle, underlineLinkStyle } = ComponentSettings;
  const StyledLearnMoreLink = isUnderlineLink ? withDefaultStyles(
    UnStyledLearnMoreLink,
    (_, { palette = {} } = {}) => ({ link: underlineLinkStyle({ palette, elementLocator: 'a.HelpTopic, a.Fwlink', isGreyBackground }) })
  ) : withDefaultStyles(
    UnStyledLearnMoreLink,
    (_, { palette = {} } = {}) => ({ link: internalLinkStyle({ palette, elementLocator: 'a.HelpTopic, a.Fwlink', isGreyBackground }) })
  );

  return <StyledLearnMoreLink {...props} />;
};

LearnMoreLink.defaultProps = {
  isUnderlineLink: true,
  isGreyBackground: false,
};

LearnMoreLink.propTypes = {
  isUnderlineLink: PropTypes.bool,
  isGreyBackground: PropTypes.bool,
};
